import {
  httpTokenCommon,
  httpTokenFileDownload,
  httpTokenFileUpload,
} from "../helper/http-common";
import {
  ApprovedIdeasDashboard,
  getAdminDashboardData,
  IdeaCaptureType,
} from "../types/adminSection";
import {
  NewJoiner,
  Holiday,
  BannerDuration,
  RewardsRecognitionAPIFormData,
  UpdateRESocialForm,
  OurMotorCycle,
  RewardsRecognitionAcceptAPI,
  AddREImageFormData,
} from "../types/dashboard/index";

class DashboardService {
  //// Dashboard Whole Search Data
  dashboardKeySearchAPI(inputData: { search: string }) {
    return httpTokenCommon.post(
      "DashBoardSearch/GetKeySearchDashBoardData",
      inputData
    );
  }
  //// Add update Banner listing
  addUpdateBannerDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("BannerMaster/manageBanners", formData);
  }
  getBannerListAPI() {
    return httpTokenCommon.get("BannerMaster/get");
  }
  getDurationtimeAPI() {
    return httpTokenCommon.get("ConfigMaster/getByKey?Key=BannerSliderTimeout");
  }
  addDurationtimeAPI(inputData: BannerDuration) {
    return httpTokenCommon.post("ConfigMaster/add", inputData);
  }
  updateDurationtimeAPI(inputData: BannerDuration) {
    return httpTokenCommon.post("ConfigMaster/update", inputData);
  }
  getFinancialYearAPI() {
    return httpTokenCommon.get("ConfigMaster/getFinancialYear");
  }

  postNewJoinersAPI(inputData: NewJoiner) {
    return httpTokenCommon.post("Dashboard/newJoiners", inputData);
  }
  //// Birthday and Work Anniversaries API
  postBirthdayWorkAnniversariesAPI(inputData: NewJoiner) {
    return httpTokenCommon.post("Dashboard/wishes", inputData);
  }
  getStatesAPI() {
    return httpTokenCommon.get("LocationMaster/regions");
  }
  getLocationMasterAPI() {
    return httpTokenCommon.get("LocationMaster/locations");
  }
  postUserSendWishesAPI = (
    inputData: { userId: string; eventDate: string; wishType: number }[]
  ) => {
    return httpTokenCommon.post("Dashboard/sendWishes", inputData);
  };
  //// get Leadership Type list
  getLeadershipTypeAPI() {
    return httpTokenCommon.get("LeadershipCorner/getTypes");
  }
  postHolidaysAPI(inputData: Holiday) {
    return httpTokenCommon.post("Dashboard/holidays", inputData);
  }

  addHolidaysDataAPI(inputData: Holiday) {
    return httpTokenCommon.post("HolidayMaster/add", inputData);
  }
  importHolidaysDataAPI(inputData: FormData) {
    return httpTokenFileUpload.post("HolidayMaster/import", inputData);
  }
  updateHolidaysDataAPI(inputData: Holiday) {
    return httpTokenCommon.put("HolidayMaster/update", inputData);
  }
  deleteHolidaysDataAPI(holidayId: number) {
    return httpTokenCommon.delete(`HolidayMaster/delete/${holidayId}`);
  }
  //space card Services
  getSpaceCardDataAPI() {
    return httpTokenCommon.get("Space/GetSpaceData");
  }
  addUpdateSpaceDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("Space/AddUpdateSpace", formData);
  }

  deleteSpacesDataAPI(id: number) {
    return httpTokenCommon.post(`Space/DeleteRecord?Id=${id}`);
  }
  /// Learning and Development card services
  getLearningAndDevelopmentAPI() {
    return httpTokenCommon.get("LearningAndDevelopment/get");
  }
  addLearningDevelopmentDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("LearningAndDevelopment/add", formData);
  }
  updateLearningDevelopmentDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("LearningAndDevelopment/update", formData);
  }
  deleteLearningDevelopmentDataAPI(id: number) {
    return httpTokenCommon.delete(`LearningAndDevelopment/delete/${id}`);
  }

  //// Leadership corner APis
  getLeadershipCornerDataAPI(searchText: string) {
    return httpTokenFileUpload.post(
      `LeadershipCorner/GetLeadershipCornerData?search=${searchText}`
    );
  }
  addLeadershipCornerDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("LeadershipCorner/add", formData);
  }
  updateLeadershipCornerDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("LeadershipCorner/update", formData);
  }
  deleteLeadershipCornerDataAPI(id: number) {
    return httpTokenCommon.post(`LeadershipCorner/DeleteRecord?Id=${id}`);
  }

  //// Wallpaper APIs
  getWallpaperAPI() {
    return httpTokenCommon.get("Wallpaper/get");
  }
  addWallpaperAPI(formData: FormData) {
    return httpTokenFileUpload.post("Wallpaper/add", formData);
  }
  updateWallpaperDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("Wallpaper/update", formData);
  }
  deleteWallpaperDataAPI(id: number) {
    return httpTokenCommon.delete(`Wallpaper/delete/${id}`);
  }

  //  Internal job posting API service
  getInternalJobPostingAPI() {
    return httpTokenCommon.get("InternalJobPosting/GetInternalJobPostingData");
  }
  addUpdateInternalJobPostingData(formData: FormData) {
    return httpTokenFileUpload.post(
      "InternalJobPosting/AddUpdateInternalJobPosting",
      formData
    );
  }
  deleteInternalJobPostingData(id: number) {
    return httpTokenCommon.post(`InternalJobPosting/DeleteRecord?Id=${id}`);
  }

  /// Performance Management card services
  getPerformanceManagementAPI() {
    return httpTokenCommon.get("PerformanceManagement/get");
  }
  addPerformanceManagementDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("PerformanceManagement/add", formData);
  }
  updatePerformanceManagementDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("PerformanceManagement/update", formData);
  }
  deletePerformanceManagementDataAPI(id: number) {
    return httpTokenCommon.delete(`PerformanceManagement/delete/${id}`);
  }

  /// RE Social card services
  getRESocialAPI() {
    return httpTokenCommon.get("RESocial/get");
  }
  updateRESocialDataAPI(inputData: UpdateRESocialForm) {
    return httpTokenCommon.put("RESocial/update", inputData);
  }

  //// Open Road APis
  getOpenRoadDataAPI(searchText: string) {
    return httpTokenCommon.get(`OpenRoad/get?search=${searchText}`);
  }
  getOpenRoadTypeAPI() {
    return httpTokenCommon.get("OpenRoad/getTypes");
  }
  addOpenRoadDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("OpenRoad/add", formData);
  }
  updateOpenRoadDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("OpenRoad/update", formData);
  }
  deleteOpenRoadDataAPI(id: number) {
    return httpTokenCommon.delete(`OpenRoad/delete/${id}`);
  }

  //// Rewards and Recognition APIs
  postUserListAPI(inputData: { searchTerm: string; rewardId: number }) {
    return httpTokenCommon.post("User/searchUsersForRR", inputData);
  }
  getPointMasterAPI() {
    return httpTokenCommon.get("RewardAndRecognization/getPointsMaster");
  }
  GetRewardAndRecognizationDataAPI(inputData: {
    startDate: string;
    endDate: string;
  }) {
    return httpTokenCommon.post("RewardAndRecognization/get", inputData);
  }
  AddRewardAndRecognizationDataAPI(inputData: RewardsRecognitionAPIFormData) {
    return httpTokenCommon.post("RewardAndRecognization/add", inputData);
  }
  GetRewardAndRecognizationApproveRejectAPI(
    inputData: RewardsRecognitionAcceptAPI
  ) {
    return httpTokenCommon.post(
      "RewardAndRecognization/approveRejectCertificate",
      inputData
    );
  }
  getCriteriaByAwardIdAPI(id: number) {
    return httpTokenCommon.get(
      `RewardAndRecognization/getCriteriaByAwardId/${id}`
    );
  }
  postRandRUserSendWishesAPI = (
    inputData: {
      userId: string;
      crossFunctionalTypeId: number;
      wishType: number;
      awardId: number;
    }[]
  ) => {
    return httpTokenCommon.post("RewardAndRecognization/sendWishes", inputData);
  };
  //// OurMotorcycle APIs
  getMotorCycleData() {
    return httpTokenCommon.get("OurMotorcycle/get");
  }
  addMotorCycleData(inputData: OurMotorCycle) {
    return httpTokenCommon.post("OurMotorcycle/add", inputData);
  }
  updateMotorCycleData(inputData: OurMotorCycle) {
    return httpTokenCommon.put("OurMotorcycle/update", inputData);
  }
  deleteMotorCycleData(id: number) {
    return httpTokenCommon.delete(`OurMotorcycle/delete/${id}`);
  }

  // NPI APIs
  getNPIData() {
    return httpTokenCommon.get("NPI/get");
  }
  addNPIData(formData: FormData) {
    return httpTokenFileUpload.post("NPI/add", formData);
  }
  updateNPIData(formData: FormData) {
    return httpTokenFileUpload.put("NPI/update", formData);
  }
  deleteNPIData(id: number) {
    return httpTokenCommon.delete(`NPI/delete/${id}`);
  }

  // UseFull Links APIs
  getUseFullLinksData() {
    return httpTokenCommon.get("UsefullLinks/get");
  }
  addUseFullLinksData(formData: FormData) {
    return httpTokenFileUpload.post("UsefullLinks/add", formData);
  }
  updateUseFullLinksData(formData: FormData) {
    return httpTokenFileUpload.put("UsefullLinks/update", formData);
  }
  deleteUseFullLinksData(id: number) {
    return httpTokenCommon.delete(`UsefullLinks/delete/${id}`);
  }

  //// Social Mission APis
  getSocialMissionDataAPI(searchText: string) {
    return httpTokenFileUpload.get(`OurSocialMission/get?search=${searchText}`);
  }
  getSocialMissionTypeAPI() {
    return httpTokenCommon.get("OurSocialMission/getTypes");
  }
  addSocialMissionDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("OurSocialMission/add", formData);
  }
  updateSocialMissionDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("OurSocialMission/update", formData);
  }
  deleteSocialMissionDataAPI(id: number) {
    return httpTokenCommon.delete(`OurSocialMission/delete/${id}`);
  }

  //// Events APis
  getEventsDataAPI(searchText: string) {
    return httpTokenFileUpload.get(`Events/get?search=${searchText}`);
  }
  getEventsTypeAPI() {
    return httpTokenCommon.get("Events/getTypes");
  }
  addEventsDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("Events/add", formData);
  }
  updateEventsDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("Events/update", formData);
  }
  deleteEventsDataAPI(id: number) {
    return httpTokenCommon.delete(`Events/delete/${id}`);
  }

  //// iRefer - Employee Referral APis
  getEmployeeIReferralDataAPI() {
    return httpTokenCommon.get("IRefer/get");
  }
  getDepartmentDataAPI() {
    return httpTokenCommon.get("DepartmentMaster/get");
  }
  addEmployeeIReferralDataAPI(formData: FormData) {
    return httpTokenFileUpload.post("IRefer/add", formData);
  }
  updateEmployeeIReferralDataAPI(formData: FormData) {
    return httpTokenFileUpload.put("IRefer/update", formData);
  }
  deleteEmployeeIReferralDataAPI(id: number) {
    return httpTokenCommon.delete(`IRefer/delete/${id}`);
  }

  ///REImagine APis
  getApprovalListByDepartmentIdAPI(id: string) {
    return httpTokenFileUpload.get(
      `REImagine/getApprovalListByDepartmentId/${id}`
    );
  }
  GetREImagineDataAPI(inputData: { startDate: string; endDate: string }) {
    return httpTokenCommon.post("REImagine/get", inputData);
  }
  addREImagineData(inputData: AddREImageFormData) {
    return httpTokenCommon.post("REImagine/add", inputData);
  }
  updateREImagineDataAPI(inputData: AddREImageFormData) {
    return httpTokenCommon.put("REImagine/update", inputData);
  }
  GetREImagineAceecsApproveRejectAPI(id: string | number) {
    return httpTokenCommon.get(`REImagine/getById/${id}`);
  }
  addREImagineAccessAPI(inputData: AddREImageFormData) {
    return httpTokenCommon.post("REImagine/handleRequestOutcome", inputData);
  }
  GetOtherDetailsAPI() {
    return httpTokenCommon.get("REImagine/getOtherDetails");
  }
  GetRewardAndRecognitionStatusAPI(id: number | string) {
    return httpTokenCommon.get(`RewardAndRecognization/getById/${id}`);
  }

  RewardAndRecoApproveReject(inputData: { id: number; status: number }) {
    return httpTokenCommon.post(
      "RewardAndRecognization/approveRejectCertificate",
      inputData
    );
  }
  RRApprovalPendingList(inputData: getAdminDashboardData) {
    return httpTokenCommon.post(
      "RewardAndRecognization/approval-pending-list",
      inputData
    );
  }
  getDivisionListAPI() {
    return httpTokenCommon.get("REImagine/getDivisionList");
  }
  GetFunctionListByDivisionIdAPI(division: string) {
    return httpTokenCommon.get(
      `REImagine/GetFunctionListByDivision/${division}`
    );
  }
  GetSubFunctionByFunctionAPI(functionName: string) {
    return httpTokenCommon.get(
      `REImagine/getSubFunctionByFunction/${functionName}`
    );
  }
  GetApprovalNameBySubFunctionAPI(subfunction: string) {
    return httpTokenCommon.get(`REImagine/getApprovalName/${subfunction}`);
  }
  getOtherQuestionListAPI() {
    return httpTokenCommon.get("REImagine/getQuestions");
  }

  /// RE Imagine Configuration
  REImagineConfiguration(inputData: IdeaCaptureType) {
    return httpTokenCommon.put("REImagineConfiguration/update", inputData);
  }
  GetConfigurationData() {
    return httpTokenCommon.get("REImagineConfiguration/getConfigurationData");
  }
  /// RE Imagine Is-ideathon-active
  REImagineConfigurationIsIdeathon() {
    return httpTokenCommon.get("REImagineConfiguration/is-ideathon-active");
  }
  getBudgetDataofCXOorHead(EmpId: string) {
    return httpTokenCommon.get(`RRBudget/getBudgetDataofCXOorHead/${EmpId}`);
  }

  getApprovedIdeasTableDataSPOC(inputData: ApprovedIdeasDashboard) {
    return httpTokenCommon.post(`/REImagine/getApprovedIdeas`, inputData);
  }
  updateApprovedIdeasTableDataSPOC(inputData: ApprovedIdeasDashboard) {
    return httpTokenCommon.put(`/REImagine/updateApprovedIdea`, inputData);
  }
  exportApprovedIdeasTableDataSPOC(input: ApprovedIdeasDashboard) {
    return httpTokenFileDownload.post(
      "REImagine/exportImplementationPending",
      input,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
